import type { JoinLinkSummaryResponse } from "@/types/generated/cms.generated";

/** Every generated property is optional: a missing number is 0. */
export const num = (value: number | null | undefined): number => value ?? 0;

/** Thousands separators ("1,284"). */
export const formatCount = (value: number | null | undefined): string => num(value).toLocaleString("en-US");

/** The link as shown on screen: the server's `joinUrl` without its scheme. */
export const linkLabel = (joinUrl: string | null | undefined): string => (joinUrl ?? "").replace(/^https?:\/\//i, "");

/** iPhone + Android opens — the only opens that count as phone opens. */
export const phoneOpens = (row: JoinLinkSummaryResponse): number => num(row.opens?.ios) + num(row.opens?.android);

/** "N of M", or "N of —" when the company has no current subscription (`seatsTotal` absent). */
export const seatsLabel = (row: JoinLinkSummaryResponse): string =>
  `${formatCount(row.seatsUsed)} of ${row.seatsTotal == null ? "—" : formatCount(row.seatsTotal)}`;

/** The app's display name ("Athlyn" when the server sends none). */
export const appLabel = (row: JoinLinkSummaryResponse): string => row.appName?.trim() || "Athlyn";

/**
 * The shown link split into a host part that may be cut off and a tail that never is
 * (`/join/<subdomain>`; else from the last "/") — the subdomain is what the team reads.
 */
export function splitLinkLabel(joinUrl: string | null | undefined): { head: string; tail: string } {
  const label = linkLabel(joinUrl);
  const at = label.lastIndexOf("/join/");
  const cut = at >= 0 ? at : label.lastIndexOf("/");
  return cut > 0 ? { head: label.slice(0, cut), tail: label.slice(cut) } : { head: "", tail: label };
}
